@if (shouldBeExtended()) {
  <img
    aria-label="Logo"
    class="w-full"
    alt="Logo L&D Support"
    [src]="logoExtended"
  />
} @else {
  <img
    aria-label="Logo"
    alt="Logo L&D Support"
    [height]="54"
    [src]="logoMini"
  />
}
